export default __webpack_public_path__ + "static/media/female_white.95fb7005.svg";